export const GET_INQUIRIES = 'GET_INQUIRIES'
export const GET_INQUIRY = 'GET_INQUIRY'
export const UPDATE_INQUIRY = 'UPDATE_INQUIRY'
export const SEND_INQUIRY_MESSAGE = 'SEND_INQUIRY_MESSAGE'
export const CREATE_INQUIRY = 'CREATE_INQUIRY'
export const GET_INQUIRY_TYPES = 'GET_INQUIRY_TYPES'
export const DELETE_INQUIRY = 'DELETE_INQUIRY'
export const DELETE_INQUIRIES = 'DELETE_INQUIRIES'
